import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import AdmissionsSection from './components/AdmissionsSection';
import AboutSection from './components/AboutSection';
import ProgramsSection from './components/ProgramsSection';
import InstructorsSection from './components/InstructorsSection';
import ScheduleSection from './components/ScheduleSection';
import ContactSection from './components/ContactSection';
import PopupBanner from './components/PopupBanner';

function GoldDivider() {
  return (
    <div className="relative w-full overflow-hidden" style={{ height: '4px' }}>
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, #b8860b 15%, #ffd700 30%, #fffacd 50%, #ffd700 70%, #b8860b 85%, transparent 100%)',
        }}
      />
      <div
        className="absolute inset-0 animate-gold-shine"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, transparent 30%, rgba(255,255,255,0.7) 50%, transparent 70%, transparent 100%)',
          backgroundSize: '200% 100%',
        }}
      />
    </div>
  );
}

export default function Home() {
  return (
    <div className="min-w-[1024px]">
      <style>{`
        @keyframes goldShine {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(300%); }
        }
        .animate-gold-shine {
          animation: goldShine 2.5s ease-in-out infinite;
        }
      `}</style>
      <PopupBanner />
      <Navbar />
      <main>
        <HeroSection />
        <GoldDivider />
        <AdmissionsSection />
        <GoldDivider />
        <AboutSection />
        <GoldDivider />
        <ProgramsSection />
        <GoldDivider />
        <InstructorsSection />
        <GoldDivider />
        <ScheduleSection />
        <GoldDivider />
        <ContactSection />
      </main>
    </div>
  );
}